import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";
import { usePagination } from "@/utils/stores/pagination";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "notary";

export const useNotaryStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "attributes.name");
  const { paginatedResources, goToPage, goToNextPage, goToPreviousPage, paginationRange, totalPages, currentPage } = usePagination(sortedResources, 10);
  const { baseFetchOne, baseFetchAll, baseSave, baseDelete, watchRemoteResourceChange } = useBase(storeName);

  const empty = {};

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("notaries", errorCallback);
  };

  const fetchOne = async (id, errorCallback) => {
    return await baseFetchOne("notaries", id, errorCallback);
  };

  const create = async (notaryData, callback, errorCallback) => {
    await baseSave("notaries", notaryData, async (created) => {
      await fetchAll();
      callback && callback(created);
    }, errorCallback);
  };

  const update = async (notaryData, callback, errorCallback) => {
    await baseSave("notaries", notaryData, async (updated) => {
      await fetchAll();
      callback && callback(updated);
    }, errorCallback);
  };

  const destroy = async (id, callback, errorCallback) => {
    await baseDelete("notaries", id, async () => {
      await fetchAll();
      callback && callback();
    }, errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    all,
    create,
    currentPage,
    destroy,
    empty,
    fetchAll,
    fetchOne,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: paginatedResources,
    paginationRange,
    searchQuery,
    sorted: sortedResources,
    totalPages,
    update,
  };
});
